import { ResourceEvent } from '/@types/resources';

export function isSubEvent(event: ResourceEvent): boolean {
  return event.linkedByGuid != null && event.resourceType === 'user';
}

export function isNightTime(event: ResourceEvent): boolean {
  return event.fromDate.getHours() >= 18 || event.fromDate.getHours() <= 6;
}